/** Dialog width for the PO# mapping modal. */
export const PO_MAPPING_MODAL_WIDTH = '40rem';
